export default function dontForward(...props: Array<string>): object {

    return { shouldForwardProp: ((key: string) => !props.includes(key)) };
}